import { parseISO } from "date-fns";

/**
 * Returns true when the given ISO string represents the same UTC instant as one
 * of the provided options. Comparison is on UTC ms so formatISO output with a
 * timezone offset is treated as equivalent to toISOString() output with Z.
 */
export function isEtaInOptions(arrivalTimeIso: string, options: readonly Date[]): boolean {
  const selected = parseISO(arrivalTimeIso);
  const selectedMs = selected.getTime();
  if (Number.isNaN(selectedMs)) {
    return false;
  }
  return options.some((option) => option.getTime() === selectedMs);
}
